import { RefreshCw } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { useAtom } from "jotai";
import { userIdentity } from "@/app/store";
import { useState } from "react";
import { authService } from "@/app/services/authService";
import { Step } from "../components/types";

interface AnalisingProps {
  goToNextStep: (step: Step) => void;
}

const Analising = ({ goToNextStep }: AnalisingProps) => {
  const [userIdentityData] = useAtom(userIdentity);
  const [isChecking, setIsChecking] = useState(false);

  const handleCheckStatus = async () => {
    if (!userIdentityData.id) {
      console.error("ID do usuário não encontrado");
      return;
    }

    setIsChecking(true);
    try {
      const response = await authService.checkUser(userIdentityData.id);

      switch (response.status) {
        case "approved":
          goToNextStep("RegisterApproved");
          break;
        case "not_approved":
          goToNextStep("RegisterDenied");
          break;
        case "retry":
          goToNextStep("validate-identity");
          break;
        default:
          console.log("Status desconhecido:", response.status);
      }
    } catch (error) {
      console.error("Erro ao verificar status:", error);
    } finally {
      setIsChecking(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center gap-4 sm:gap-6 text-black03 px-4">
      <div className="flex flex-col items-center gap-3 sm:gap-4 text-center max-w-md">
        <h2 className="text-lg sm:text-2xl font-semibold">Analisando seus dados</h2>
        <p className="text-xs sm:text-sm leading-relaxed">
          Estamos processando seu cadastro. Nossa equipe irá confirmar seus
          dados. Para saber se a análise foi concluída, clique
          &ldquo;Atualizar&rdquo;.
        </p>

        <Button
          type="button"
          onClick={handleCheckStatus}
          disabled={isChecking}
          className="mt-2 sm:mt-4 h-11 sm:h-12 bg-primary px-6 sm:px-8 text-white hover:bg-primary/90 text-sm sm:text-base w-full sm:w-auto"
        >
          {isChecking ? (
            <>
              <RefreshCw className="mr-2 h-3 w-3 sm:h-4 sm:w-4 animate-spin" />
              Verificando...
            </>
          ) : (
            "Atualizar"
          )}
        </Button>
      </div>
    </div>
  );
};

export default Analising;
